"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activitiesDeeplink = activitiesDeeplink;
exports.flightsDeeplink = flightsDeeplink;
exports.hotelDeeplink = hotelDeeplink;
exports.returnFlightSearchArray = void 0;
exports.snapDeeplinkURL = snapDeeplinkURL;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _services = require("../HotelSearchWidget/services");
var _config = require("../HotelSearchWidget/config");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _utils = require("../FlightSearchWidget/utils");
var _constant = require("../FlightSearchWidget/constant");
var _dateFns = require("date-fns");
/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
function hotelDeeplink(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
  return _hotelDeeplink.apply(this, arguments);
}
function _hotelDeeplink() {
  _hotelDeeplink = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(placeholderUrl, StationName, adultCount, childCount, unformattedDates, locale, currency, environment) {
    var ppConfig, listOfSuggestion, listOfCities, cCode, cId, furl;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ppConfig = _config.envConfig[environment];
          _context.prev = 1;
          _context.next = 4;
          return (0, _services.getSuggestions)(StationName, ppConfig, locale, false);
        case 4:
          listOfSuggestion = _context.sent;
          if (!(listOfSuggestion && listOfSuggestion.suggestions)) {
            _context.next = 11;
            break;
          }
          listOfCities = listOfSuggestion.suggestions.filter(function (h) {
            return h.type === 'city';
          });
          cCode = listOfCities[0].country_code;
          cId = listOfCities[0].city_id;
          furl = placeholderUrl.replace('{{countryCode}}', cCode).replace('{{d_id}}', cId).replace('{{locale}}', locale).replace('{{adultCount}}', adultCount).replace('{{childCount}}', childCount).replace('{{fromDate}}', unformattedDates.departureDate).replace('{{toDate}}', unformattedDates.returnDate === 'N' ? '' : unformattedDates.returnDate).replace('{{currency}}', currency);
          return _context.abrupt("return", furl);
        case 11:
          return _context.abrupt("return", window.location.href);
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](1);
          console.error('MultiLob Hotel failed', _context.t0);
          return _context.abrupt("return", window.location.href);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 14]]);
  }));
  return _hotelDeeplink.apply(this, arguments);
}
function activitiesDeeplink(_x9, _x10) {
  return _activitiesDeeplink.apply(this, arguments);
}
function _activitiesDeeplink() {
  _activitiesDeeplink = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(placeholderUrl, iataCode) {
    var _bb$, a, bb;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return _utilities.default.get(placeholderUrl);
        case 3:
          a = _context2.sent;
          bb = a.data.filter(function (ac) {
            return ac.attributes.iata_code === iataCode;
          });
          return _context2.abrupt("return", ((_bb$ = bb[0]) === null || _bb$ === void 0 || (_bb$ = _bb$.links) === null || _bb$ === void 0 ? void 0 : _bb$.url) || window.location.href);
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          console.error('MultiLob Activities failed', _context2.t0);
          return _context2.abrupt("return", window.location.href);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return _activitiesDeeplink.apply(this, arguments);
}
function snapDeeplinkURL(_x11, _x12, _x13, _x14, _x15, _x16, _x17) {
  return _snapDeeplinkURL.apply(this, arguments);
}
function _snapDeeplinkURL() {
  _snapDeeplinkURL = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(placeholderUrl, orig, dest, locale, currency, unformattedDates, adultCount) {
    var today, AA_DATE_FORMAT, todayFormatted, dDate, rDate, newDdate, date1, deeplinkSnap;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          today = new Date();
          AA_DATE_FORMAT = 'yyyy-MM-dd';
          todayFormatted = (0, _dateFns.format)(today, AA_DATE_FORMAT);
          dDate = unformattedDates.departureDate;
          rDate = unformattedDates.returnDate;
          /**
           * Expired Dates
           */
          if (todayFormatted > dDate) {
            newDdate = new Date();
            newDdate.setDate(today.getDate() + 7);
            dDate = (0, _dateFns.format)(newDdate, AA_DATE_FORMAT);
          }

          /**
           * Handling return dates in case of one way journey
           */
          if (todayFormatted > dDate || unformattedDates.returnDate === 'N') {
            date1 = new Date(dDate);
            date1.setDate(date1.getDate() + 3);
            rDate = (0, _dateFns.format)(date1, AA_DATE_FORMAT);
          }
          deeplinkSnap = placeholderUrl.replace('{{origin}}', orig).replace('{{destination}}', dest).replace('{{locale}}', locale).replace('{{curr}}', currency).replace('{{adults}}', adultCount).replace('{{fromDateFlight}}', dDate).replace('{{toDateFlight}}', rDate);
          return _context3.abrupt("return", deeplinkSnap);
        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](0);
          console.error('MultiLob Snap failed', _context3.t0);
          return _context3.abrupt("return", window.location.href);
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 12]]);
  }));
  return _snapDeeplinkURL.apply(this, arguments);
}
var returnFlightSearchArray = function returnFlightSearchArray(cookieObject) {
  try {
    return cookieObject && cookieObject.map(function (itemString) {
      var item = itemString.split('|');
      var object = {
        origin: {
          StationCode: item[0]
        },
        destination: {
          StationCode: item[1]
        },
        isKiwiRoute: item[16] === 'true',
        route: {
          origin: item[0],
          destination: item[1],
          originStationName: item[5],
          isOriginKiwiStation: item[14] === 'true',
          isDestinationKiwiStation: item[15] === 'true',
          originCountry: item[2]
        },
        destinationCountry: item[3],
        destinationStationName: item[4],
        dates: {
          departureDate: Date.parse(item[6]),
          returnDate: Date.parse(item[7])
        },
        unformattedDates: {
          departureDate: item[6],
          returnDate: item[7]
        },
        passengers: {
          adult: Number(item[8]),
          child: Number(item[9]),
          infant: Number(item[10])
        },
        tripType: item[11],
        createdAt: item[12],
        promoCode: item[13]
      };
      if (item[7] === 'N') {
        delete object.dates.returnDate;
      }
      console.log(object);
      return object;
    });
  } catch (e) {
    console.log('(Not breaking page)Error : ', e);
    return null;
  }
};
exports.returnFlightSearchArray = returnFlightSearchArray;
function flightsDeeplink(_x18, _x19, _x20, _x21, _x22, _x23, _x24, _x25, _x26) {
  return _flightsDeeplink.apply(this, arguments);
}
function _flightsDeeplink() {
  _flightsDeeplink = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(origin, destination, dates, tripType, passengers, promoCode, locale, currency, environment) {
    var flightDeeplink, finalRedirectionUrl;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _utils.generateRedirectPathWithoutDeepLink)(origin, destination, dates, tripType, passengers, promoCode, locale, currency, environment);
        case 3:
          flightDeeplink = _context4.sent;
          finalRedirectionUrl = _constant.ENVIRONMENT_URL[environment].AA_BASE_URL + flightDeeplink;
          return _context4.abrupt("return", finalRedirectionUrl);
        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](0);
          console.error('MultiLob Flight failed', _context4.t0);
          return _context4.abrupt("return", window.location.href);
        case 12:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 8]]);
  }));
  return _flightsDeeplink.apply(this, arguments);
}